class LayoutContainer extends HTMLElement {
  constructor() {
    super();
    console.log('LayoutContainer');
  }
}

customElements.define("layout-container", LayoutContainer);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    this.input.setAttribute('previous-opt', event.target.name);
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button =>{ 
      if(!$(button).hasClass("localization-form__select")){
         button.addEventListener('click', this.onCloseButtonClick.bind(this))
      }  
     
                                                     
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {

    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  // 禁止在BODY 显示弹窗
  // connectedCallback() {
  //   if (this.moved) return;
  //   this.moved = true;
  //   document.body.appendChild(this);
  // }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }
  
  before () {}
  
  after() {}

  onVariantChange(e) {
    this.before(e);
    this.updateOptions(e);
    this.renderVariantOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.filterMedia();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    
    this.after();
  }

  filterMedia() {
    $('[thumbnail-color]').hide();
    var selected_variant = this.currentVariant.featured_media.alt;
    var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
    if (selected_variant == selected_variant) {
      $(selected_attribute).show();
     }
   }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(`price-${this.dataset.section}`);
      const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      if (source && destination) destination.innerHTML = source.innerHTML;
      
      this.renderPrice(html);
      this.renderMarketingCampaignPrice(html);

      const price = document.getElementById(`price-${this.dataset.section}`);
      const discount = document.getElementById(`discount-${this.dataset.section}`);
      const shippings = document.getElementById(`shippings-${this.dataset.section}`);
      const metafields = document.getElementById(`metafields-${this.dataset.section}`);
      const delivery = document.getElementById(`delivery-${this.dataset.section}`);
      const coupons = document.getElementById(`coupons-${this.dataset.section}`);

      if (price) price.classList.remove('visibility-hidden');
      if (discount) discount.classList.remove('visibility-hidden'), this.updateDiscount(html);
      if (shippings) shippings.classList.remove('visibility-hidden'), this.updateShippings(html);
      if (metafields) metafields.classList.remove('visibility-hidden'), this.updateMetafields(html);
      if (delivery) delivery.classList.remove('visibility-hidden'), this.updateDelivery(html);
      if (coupons) coupons.classList.remove('visibility-hidden'), this.updateCoupons(html);
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      
      this.renderSaleItem(html);
    });
  }
  
  renderVariantOptions () { }
  
  renderSaleItem(html) {
    if (window.Shopify && window.Shopify.cartService) {
      window.Shopify.cartService.resetCustomItems();
    }
    document.querySelectorAll("[data-sale-item-block]").forEach((saleItemBlock) => {
      const sourceBlock = html.getElementById(saleItemBlock.id);
      if (sourceBlock) saleItemBlock.outerHTML = sourceBlock.outerHTML;
    });
  }
  
  renderPrice (html) {
    const id = `price-${this.dataset.section}`;
    const destination = document.querySelectorAll('.product-price-handler');
    const source = html.getElementById(id);
  
    if (source && destination.length > 0) {
      for (let i = 0; i < destination.length; i++) {
        destination[i].innerHTML = source.innerHTML;
      }
    }
  }

  renderMarketingCampaignPrice(html) {
    const destinations = document.querySelectorAll('.marketing-campaign-callery-content-price');
    const sources = html.querySelectorAll('.marketing-campaign-callery-content-price');

    for (let i = 0; i < destinations.length && i < sources.length; i++) {
      destinations[i].innerHTML = sources[i].innerHTML;
      destinations[i].style.display = sources[i].style.display;
    }
  }

  updateDiscount(html){
    const id = `discount-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
  
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateShippings(html) {
    const id = `shippings-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
  
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateMetafields(html) {
    const id = `metafields-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
  
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateDelivery(html) {
    const id = `delivery-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
  
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateCoupons(html) {
    const id = `coupons-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
  
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const discount = document.getElementById(`discount-${this.dataset.section}`);
    const shippings = document.getElementById(`shippings-${this.dataset.section}`);
    const metafields = document.getElementById(`metafields-${this.dataset.section}`);
    const delivery = document.getElementById(`delivery-${this.dataset.section}`);
    const coupons = document.getElementById(`coupons-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (discount) discount.classList.add('visibility-hidden');
    if (shippings) shippings.classList.add('visibility-hidden');
    if (metafields) metafields.classList.add('visibility-hidden');
    if (delivery) delivery.classList.add('visibility-hidden');
    if (coupons) coupons.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class VariantsRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variants-radios', VariantsRadios);

class ModalDialogForm extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog-form', ModalDialogForm);

class VariantRadiosEnhance extends VariantSelects {
  constructor() {
    super();
    this.initOptionListObject();
    this.updateOptions()
    this.renderVariantOptions();
    this.validateExistVariantOption()
  }
  
  initOptionListObject () {
    const variantData = JSON.parse(this.querySelector('#product-variants-info').textContent);
    
    const optionsListObject = {};
    const optionList = [];
    
    for (let i = 0; i < variantData.length; i++) {
      const { options, available, inventory_quantity } = variantData[i];
      optionsListObject[options.join('/').trim()] = {
        available,
        inventory_quantity: inventory_quantity,
        len: options.length
      };
      optionList.push(options);
    }
    
    
    this.optionsListObject = optionsListObject;
    this.optionList = optionList;
  }
  
  // Needing to verify that the options selected are present.
  updateOptions (e) {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
    
    if (e) {
      const optionsKey = this.options.join('/').trim();
      // if the selected option was not present, you needed to update the option
      if (!this.optionsListObject[optionsKey]) {
        // Record the option you selected at this moment.
        const target = e.target;
        const val = target.value;
        const option = this.findFirstExsitVariant(val);
        if (option) {
          this.options = option.split('/');
        }
      }
    }
  }
  
  // Base the current selected option, find the frist variant at the option list
  findFirstExsitVariant (val) {
    const ret = null;
    
    const keys = Object.keys(this.optionsListObject);
    
    for (let i = 0; i< keys.length; i++) {
      const option = keys[i];
      if (option.includes(val)) {
        return option;
      }
    }
    
    return ret;
  }
  
  // Based on the selected option, update the list of variant options.
  renderVariantOptions () {
    this.renderVariantOptionList();
    this.renderSelectOption();
  }

  // When the user has selected an option, and this causes another previously selected option at a diffrence level to be hidden,
  // we should set the first option that was not hidden to the selected state.
  renderSelectOption () {
    // need to select option by postion
    const radiosWrappers = document.querySelectorAll('variant-radios-enhance .variant-option-wrapper');
    radiosWrappers.forEach(wrapper => {
      const radiosItems = wrapper.querySelectorAll('.variant-option-item:not(.unavailable) input[type="radio"]');
      const options = this.options;
      
      for (let i = 0; i < radiosItems.length; i++) {
        if (options.includes(radiosItems[i].value)) {
          radiosItems[i].checked = true;
          $(radiosItems[i]).trigger('change');
        }
      }
    });
    
    this.updateOptions();
    this.updateUpColor();
  }
  
  updateUpColor () {
    var U_color = document.getElementById('color_label');
    const modelNode = document.querySelector('#color_fieldset input:checked');
    U_color.innerHTML = $(modelNode).attr('value');
  }
  
  /**
   * Remove options that don't have any variants.
   */
  validateExistVariantOption () {
    const optionList = this.optionList;
    const radiosTitemList = document.querySelectorAll(`variant-radios-enhance .variant-option-wrapper:not([data-lock]) .variant-option-item`);
    radiosTitemList.forEach((element) => {
      const value = element.getAttribute('data-value');
      const pos = element.getAttribute('data-pos');
      let flag = false;
      for (let i = 0; i < optionList.length; i++) {
        if (optionList[i][+pos - 1].includes(value)) {
          flag = true;
        }
      }
      
      if (!flag) {
        element.classList.add('hidden');
      } else {
        element.classList.remove('hidden');
      }
    })
  }
  
  renderVariantOptionList() {
    const options = this.options;
    const optionList = this.optionList;
    
    // core logic:
    // Since only one option can be selected at a time, the options that can be selected at each level are controlled by other additional attributes.
    // Then you only need to remove the currently selected options on each layer, and then use other options to get the options that can be selected on the current layer.
    // Then cycle through each layer.
    if (this.options) {
      let optionFilterMap = {}
      for (let i = 0; i < options.length; i++) {
        let condition = [];
        for (let t = 0; t < options.length; t++) {
          if (t !== i) {
            condition.push(options[t]);
          }
        }
        
        let tempRes = [];
        for (let k = 0; k < optionList.length; k++) {
          let elements = optionList.filter(item => 
            condition.every(element => item.includes(element))
          );
          for (let j = 0; j < elements.length; j++) {
            if (!tempRes.includes(elements[j][i])) {
              tempRes.push(elements[j][i]);
            }
          }
        }
        optionFilterMap[i] = tempRes;
      }
      
      console.log('optionFilterMap', optionFilterMap);
      console.log('options', this.options);
      console.log('optionList', this.optionList);
      
      Object.keys(optionFilterMap).forEach((key) => {
        const radiosWrapper = document.querySelector(`variant-radios-enhance .variant-option-wrapper[data-pos="${+ key + 1}"]`);
        const existVariants =  optionFilterMap[key];
        const radios = radiosWrapper.querySelectorAll('input[type="radio"]');
        
        for (let i = 0; i < radios.length; i++) {
          const radio = radios[i];
          if (existVariants.includes(radio.value)) {
            radio.parentNode.classList.remove('unavailable');
          } else {
            radio.parentNode.classList.add('unavailable');
          }
        }
      });
    }
  }
  
  filterAndRemoveOptions(variants, options) {
    return variants
      .filter(variant => {
        return options.every(option => variant.includes(option));
      })
      .map(variant => {
        return variant.filter(option => !options.includes(option));
      })
      .flat();
  }
  
  
  removeKeyFromArray(arr, key) {
    return arr.filter(item => item !== key);
  }
  
  getCheckedOptionValue (pos) {
    const radiosWrapper = document.querySelectorAll(`variant-radios-enhance .variant-option-wrapper:not([data-lock]) .variant-option-item:not([data-pos="${pos}"])`);
    const values = [];
    radiosWrapper.forEach(radioWrapper => {
      const radio = radioWrapper.querySelector('input[type="radio"]');
      if (radio.checked) {
        values.push(radio.value);
      }
    });
    
    return values;
  }
}

customElements.define("variant-radios-enhance", VariantRadiosEnhance);

class CollectionsVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.renderProductInfo();
    }
  }
  
  

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    this.currentVariant = variantData.find((variant) => {
      return variant.options.map((option) => {
        return this.options[0] === option;
      }).includes(true);
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    this.updateMedia()
  }
  
  updateMedia () {
    const mediaWrapper = this.closest('.card-product-media-wrapper');
    const current = this.currentVariant;
    const productMediaImagesList = window[`PRODUCT_MEDIAS_${current.featured_image.product_id}`];
    const currentOption = current.featured_media.alt;
    
    const productMediaImagesListFilter = productMediaImagesList && productMediaImagesList.length  ? productMediaImagesList.filter((element) => {
      return element.alt === currentOption
    }) : [];
        
    // modify link string
    const mediaImages = mediaWrapper.querySelectorAll('.card-product-image');
    console.log(currentOption);
    // set src to image
    for (let i = 0; i  < mediaImages.length; i++) {
      const mediaImage = mediaImages[i];
      mediaImage.setAttribute('src', productMediaImagesListFilter[i]['src']);
      mediaImage.setAttribute('srcset', productMediaImagesListFilter[i]['srcset']);
      mediaImage.setAttribute('alt', productMediaImagesListFilter[i]['alt']);
      mediaImage.setAttribute('width', productMediaImagesListFilter[i]['width']);
      mediaImage.setAttribute('height', productMediaImagesListFilter[i]['height']);
      mediaImage.setAttribute('sizes', productMediaImagesListFilter[i]['sizes']);
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('collections-variant-radios', CollectionsVariantRadios);

class CartService {
  constructor () {
    this.customAddCartItem = [];
    this.defaultItems = [];
    this.extraAccToCartFnCreator();
  }

  execute (executor) {
    executor(this.customAddCartItem, this);
  }

  getCustomAddCartItem () {
    return this.customAddCartItem;
  }

  getDefaultItems () {
    return this.defaultItems;
  }

  extraAccToCartFnCreator () {
    window.addExtraAccToCartFn = window.addExtraAccToCartFn || function addExtraAccToCartFn(cart) {
      const customAddCartItem = window.Shopify.cartService.getCustomAddCartItem();
      const defaultItems = window.Shopify.cartService.getDefaultItems();
      const accItems = customAddCartItem.concat(defaultItems);

      if (accItems.length) {
        let param = {
          sections: cart.getSectionsToRender().map((section) => section.id),
          items: accItems,
        };

        return fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify(param),
        });
      }
      return null;
    };
  }

  addItemToCart (items) {
    if (typeof items === 'undefined') return;
    if (!Array.isArray(items)) {
      items = [items]
    }

    this.customAddCartItem = this.customAddCartItem.concat(
      items.map(function (id) {
        return {
          id,
          quantity: 1,
        };
      })
    );
  }

  removeItemFromCart (items) {
    if (typeof items === 'undefined') return;
    if (!Array.isArray(items)) {
      items = [items]
    }

    for (let i = 0; i < this.customAddCartItem.length; i++) {
      for (let k = 0; k < items.length && i >= 0; k++) {
        if (this.customAddCartItem[i]["id"] === items[k]) {
          this.customAddCartItem.splice(i, 1);
          i--;
        }
      }
    }
  }

  // US product sections are re-rendered when the main variant changes.
  resetCustomItems() {
    this.customAddCartItem = [];
  }
}

window.Shopify = window.Shopify || {};
window.Shopify.cartService = window.Shopify.cartService || new CartService();

class ProductSale extends HTMLElement {
  constructor() {
    super();
    this.hideAssociateVariantsList = ($(this).data("hide-associate-vaiants") || "") + "";
    // The variant id of the associated Ebikie product
    this.variantId = $(this).data("variant-id") + "";
  }
}

class ProductSaleTab extends ProductSale {
  constructor() {
    super();
    this.init();
    this.event();
  }

  addAccByDefault() {
    this.items = $(this).data("variant-list") + "";
    if (typeof this.items === "undefined") {
      return;
    }
    this.default_selected = $(this).data("deafult-selected");
    this.itemsArr = this.items.split(",");

    // selected by default
    if (this.default_selected) {
      window.Shopify.cartService.addItemToCart(this.itemsArr);
    }
  }

  init() {
    let associateColor = $(this).data("associate-color");
    // if the associateColor is exist
    if (associateColor) {
      const possibleNames = [ "color", "kleur", "colour", "couleur", "colore", "farbe", "farve" ];
      const checkedNode = Array.from(
        document.querySelectorAll('input[type="radio"]')
      ).find((input) =>
        possibleNames.includes(input.name.toLowerCase()) && input.checked
      );

      let checkedColor = "";
      if (checkedNode) {
        checkedColor = checkedNode.value.toLowerCase();
      }
      if (checkedColor === associateColor.toLowerCase()) {
        this.addAccByDefault();
      } else {
        this.querySelector(".pannel-content").classList.remove("selected");
      }
    } else {
      this.addAccByDefault();
    }

    if (
      !this.hideAssociateVariantsList ||
      this.hideAssociateVariantsList.trim() === ""
    ) {
      return;
    }

    if (
      this.hideAssociateVariantsList &&
      this.hideAssociateVariantsList !== "" &&
      this.hideAssociateVariantsList.split(",").includes(this.variantId)
    ) {
      if ($(this).data("hide-type") === 0) {
        this.remove();
        this.removeHandle();
      } else {
        this.querySelector(".pannel-content-operate").remove();
        this.querySelector(".pannel-content").classList.remove("user-select");
      }
    }
  }

  event() {
    this.addEventListener("click", () => {
      if (!$(this).data("readonly") && !$(this).attr("disabled")) {
        if (
          this.hideAssociateVariantsList &&
          this.hideAssociateVariantsList !== "" &&
          this.hideAssociateVariantsList.split(",").includes(this.variantId)
        ) {
          return;
        }
        const container = this.querySelector(".pannel-content-sale-item");
        if (container.classList.contains("selected")) {
          this.querySelector(".pannel-content-sale-item").classList.remove(
            "selected"
          );
          window.Shopify.cartService.removeItemFromCart(this.itemsArr);
        } else {
          this.querySelector(".pannel-content-sale-item").classList.add(
            "selected"
          );
          window.Shopify.cartService.addItemToCart(this.itemsArr);
        }
      }
    });
  }

  removeHandle() {
    window.Shopify.cartService.removeItemFromCart(this.itemsArr);
  }
}

customElements.define("product-sale-tab", ProductSaleTab);
